import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AdaptiveButton from '../../components/AdaptiveButton';
import ButtonBar from '../../components/ButtonBar';
import Card from '../../components/Card/Card';
import ListItem from '../../components/ListItem';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';

import './AllCards.scss';

const { routes } = AppConfig;

const AllCards = () => {
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const cardsList = useSelector(state => state.card.cardsList);

	const navigate = useNavigate();

	const walletBalance = availableCurrencies.reduce((acc, currency) => acc + currency.AmountUsd, 0);

	const goToCard = hash => {
		navigate({ pathname: routes.mainPage, hash });
	};

	const goToCreateCard = () => {
		navigate(routes.openCard);
	};

	return (
		<div className='AllCards'>
			<PageHeader header={'All cards'} />
			<div className='AllCards__body'>
				<ListItem
					className='FormBlock AllCards__wallet-item'
					icon={'WALLET_FILL'}
					iconSize='medium'
					title={t('Crypto wallet')}
					description={'$' + HelperService.FormatFiatWithoutCurrency(walletBalance)}
					onSelect={() => goToCard('wallet')}
				/>
				<div className='FormBlock AllCards__cards-list'>
					{cardsList.map((card, index) => (
						<ListItem
							key={card.Id}
							className='AllCards__card-item'
							icon={'CREDIT_CARD_FILL'}
							iconSize='medium'
							title={card.Label}
							description={'$' + HelperService.FormatFiatWithoutCurrency(card.BalanceUsd)}
							onSelect={() => goToCard(card.Id.toString())}
							bottomSeparator={index < cardsList.length - 1}
							trailing={[
								<Card
									className='AllCards__list-item-card'
									Id={card.Id}
									color={card.Color}
									number={card.Number}
									cardholderName={card.CardholderName}
									paymentSystem={card.PaymentSystem}
									status={card.Status}
								/>,
							]}
						/>
					))}
				</div>
			</div>

			<ButtonBar>
				<div className='AllCards__ButtonBar'>
					<AdaptiveButton onClick={goToCreateCard} icon='PLUS_BOLD' />
				</div>
			</ButtonBar>
		</div>
	);
};

export default AllCards;
